import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-boxplot_single",
  "use": "icon-boxplot_single-usage",
  "viewBox": "0 0 100 101",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 101\" id=\"icon-boxplot_single\">\r\n<g>\r\n\t<polygon points=\"50.8,56.1 49.3,56.1 49.3,91.7 42.8,91.7 42.8,93.2 57.2,93.2 57.2,91.7 50.8,91.7 \t\" />\r\n\t<polygon points=\"57.2,25 42.8,25 42.8,32.3 57.2,32.3 57.2,33.4 42.8,33.4 42.8,56.1 57.2,56.1 \t\" />\r\n\t<polygon points=\"42.8,9.3 49.3,9.3 49.3,25 50.8,25 50.8,9.3 57.2,9.3 57.2,7.8 42.8,7.8 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/boxplot_single.svg
// module id = uQpP
// module chunks = 102